import { getPoratlHost } from 'src/components/hooks/useUtil';
const archLevel: any = 'site';
const protal_url = getPoratlHost();
const url_arr = new URL(protal_url)?.hostname.split('.');
let site_name = url_arr[0]?.replace('-site', '');
if (process.env.REACT_APP_ENV == 'UAT' || process.env.REACT_APP_ENV == 'CSV') {
  site_name = url_arr[0]?.replace('study-', '');
}
if (process.env.REACT_APP_ENV == 'SBOX'){
  site_name = 'bgsite'
}
const REACT_APP_API_ISF = `https://isf-api-${site_name}.${url_arr.slice(1).join('.')}/isf`;
const REACT_APP_API_TSDA = `https://tsda-api-${site_name}.${url_arr.slice(1).join('.')}`;
export { REACT_APP_API_ISF, REACT_APP_API_TSDA, archLevel };
